import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './styles/tokens.css';
import './styles/base.css';

import App from './App';
import { AuthProvider } from './lib/auth';
import { ThemeProvider } from './lib/theme';
import { ToastProvider } from './lib/toast';
import { LanguageProvider } from './lib/i18n';
import { ApiRequestError } from './lib/api';

/**
 * Sorgu istemcisi.
 *
 * ── NEDEN 401'DE TEKRAR DENEMIYORUZ ──────────────────────────────────────────
 * Token yenileme zaten `api.ts` icinde, istek seviyesinde yapiliyor. React
 * Query'nin ayrica denemesi, ayni istegin dort kez gitmesi demek olurdu.
 *
 * ── NEDEN 4xx'TE TEKRAR DENEMIYORUZ ──────────────────────────────────────────
 * "Yetkin yok" veya "gecersiz veri" tekrar denemekle duzelmez. Yalnizca ag
 * hatasi ve 5xx tekrar denemeye deger.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiRequestError && error.status < 500) return false;
        return failureCount < 2;
      },
      // Pencereye her donuste yeniden istek atmak, sahada tabletle calisan
      // kullanicinin veri kotasini gereksiz tuketir.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <BrowserRouter>
            <AuthProvider>
              <LanguageProvider>
                <App />
              </LanguageProvider>
            </AuthProvider>
          </BrowserRouter>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
